module.exports = __webpack_public_path__ + "media/images/flags/DM-2805ad96b3dd52dc2ab6613b021d00d9.svg";